/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { object, string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { setDeliveryDateSelectionsSalesForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const DeliveryDateSelectionsABTest = ({ featureFlags, pageType }) => {
    const dispatch = useDispatch();
    const deliveryDateSelectionSaleForceABTestData = useSelector((state) => state?.mfeCheckout?.app?.abTest?.deliveryDateSelections || {});

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'All-Checkout-Delivery Date Buttons-v1',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
    });

    if ((loading) || (!loading && !data && !error)) {
        return <></>;
    }

    if (error) {
        mbpLogger.logError({
            function: 'DeliveryDateSelections',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Delivery Dates Selections Salesforce AB test returned an error',
            jsError: error,
        });
    }

    const campaignResponses = data?.contentSF?.campaign?.campaignResponses?.[0] || {};
    if (
        campaignResponses.userGroup
        && campaignResponses.userGroup !== deliveryDateSelectionSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        let eventLabel = campaignResponses.userGroup;
        if (
            featureFlags['is-delivery-date-selections-auto-open-enabled']
            && campaignResponses.userGroup === 'Default'
        ) {
            eventLabel = 'Variation2';
        }

        dispatch(setDeliveryDateSelectionsSalesForceABTest(data.contentSF));
        dispatch(trackEvent({
            eventCategory: 'Experiment',
            eventAction: 'Delivery Date Buttons',
            eventLabel,
        }));
    }

    return <></>;
};

DeliveryDateSelectionsABTest.propTypes = {
    featureFlags: object.isRequired,
    pageType: string.isRequired,
};

export default DeliveryDateSelectionsABTest;
